// token.interceptor.ts

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { USE_CUSTOM_TOKEN } from '../constants/context-token';
import { AuthService } from '../services/auth.service';
import { TokenState } from '../../models/auth.model';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.$msaltoken();
    const customToken = request.context.get(USE_CUSTOM_TOKEN);
    if (customToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${customToken}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });
    } else {
      if (!request.url.includes('token')) {
        if (token != null && (token.expTime.getTime() - new Date().getTime()) / (60 * 1000) <= 5) {
          return this.authService.getmsalTokenforScope().pipe(
            switchMap((resp: any) => {
              const tokenState: TokenState = {
                token: resp.accessToken,
                expTime: resp.expiresOn!,
              };
              this.authService.$msaltoken.set(tokenState);
              request = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${token.token}`,
                  'Content-Type': 'application/json; charset=utf-8',
                },
              });
              return next.handle(request);
            })
          );
        } else {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token?.token}`,
              'Content-Type': 'application/json; charset=utf-8',
            },
          });
        }
      }
    }
    return next.handle(request);
  }
}
